import React, { useState, useEffect } from 'react';

function FailedAssignmentsModal({ failedAssignments, isOpen, onClose }) {
    // Show failed assignments modal when component mounts if there are failed assignments
    useEffect(() => {
        if (failedAssignments && failedAssignments.length > 0 && isOpen) {
            // Modal is already controlled by parent component
        }
    }, [failedAssignments, isOpen]);

    // Failed Inspector Card Component
    const FailedInspectorCard = ({ failedAssignment }) => {
        const [isExpanded, setIsExpanded] = useState(false);

        return (
            <div className="border border-red-200 rounded-lg bg-red-50">
                <div 
                    className="p-4 cursor-pointer rounded-t-lg hover:bg-red-100 transition-colors"
                    onClick={() => setIsExpanded(!isExpanded)}
                >
                    <div className="flex items-center justify-between">
                        <div className="flex-1">
                            <h3 className="font-medium text-red-800">
                                Inspector {failedAssignment.inspector.INSPECTOR_ID}
                            </h3>
                            <p className="text-xs text-red-500 font-medium mt-1">
                                Unrouted Inspections: {failedAssignment.inspections.length}
                            </p>
                        </div>
                        <div className="ml-4">
                            <svg 
                                className={`w-5 h-5 text-red-600 transition-transform ${isExpanded ? 'rotate-180' : ''}`} 
                                fill="none" 
                                stroke="currentColor" 
                                viewBox="0 0 24 24"
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                            </svg>
                        </div>
                    </div>
                </div>
                
                {isExpanded && (
                    <div className="border-t rounded-b-lg border-red-200 p-4 bg-white">
                        <div className="mb-3">
                            <p className="text-sm text-red-600 font-medium">
                                Reason: {failedAssignment.reason}
                            </p>
                        </div>
                        <div className="space-y-2">
                            {failedAssignment.inspections.map((inspection, idx) => (
                                <div key={idx} className="text-sm text-gray-700 border-l-2 border-red-300 pl-3 py-1">
                                    <div className="font-medium">
                                        {inspection.INSPECTION_ID}
                                    </div>
                                    <div className="text-gray-600">
                                        {inspection.Street}, {inspection.City}, {inspection.State} {inspection.Postcode}
                                    </div>
                                    {inspection.ComplaintCategory && (
                                        <div className="text-gray-500 text-xs">
                                            Category: {inspection.ComplaintCategory}
                                        </div>
                                    )}
                                    {inspection.priority && (
                                        <div className="text-gray-500 text-xs">
                                            Priority: {inspection.priority}
                                        </div>
                                    )}
                                    {inspection.Status === "Scheduled" && (
                                        <div className="text-blue-600 text-xs">
                                            Manually Scheduled: {inspection.AppointmentStart} - {inspection.AppointmentFinish}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        );
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg p-6 max-w-2xl w-full h-3/4 flex flex-col">
                <div className="flex items-center justify-between mb-4 flex-shrink-0">
                    <h2 className="text-xl font-semibold text-gray-900">
                        Failed Assignments
                    </h2>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
                
                <div className="mb-4 flex-shrink-0">
                    <p className="text-sm text-gray-600">
                        The following inspectors could not be scheduled or routed by the system. Please ensure that any manually assigned inspections result in a feasible schedule.
                    </p>
                </div>

                <div className="flex-1 overflow-y-auto">
                    <div className="space-y-3 pr-2">
                        {failedAssignments.map((failedAssignment, index) => (
                            <FailedInspectorCard 
                                key={index} 
                                failedAssignment={failedAssignment} 
                            />
                        ))}
                    </div>
                </div>

                <div className="mt-4 flex justify-end flex-shrink-0">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-600 text-white rounded-md hover:bg-gray-700 transition-colors"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
}

export default FailedAssignmentsModal;
